<template>
<div class="chapter">
<div class="inner_page">
<p class="fm_tit"><a id="page_xvii">INTRODUCTION</a></p><a id="page_xvii">
<p class="noindent">For years, I’ve published a twice-weekly e-newsletter that goes to about 65,000 subscribers.</p>
<p class="indent">Originally I dispensed strictly marketing advice. But then I broadened the scope to encompass more areas of business success and life in general.</p>
<p class="indent">As soon as I did, the reaction from subscribers was immediately and overwhelmingly positive. So I’ve continued to write my twice-weekly e-mail essays.</p>
<p class="indent">Eventually, I self-published a few of the essays as an e-book. Terry Whalin, an acquisition editor at Morgan James, read the e-book. He then suggested we add many more essays and bring it out as the paperback book you now hold in your hands.</p>
<p class="indent">Is this the best advice in the world on business, entrepreneurship, marketing, copywriting, freelancing, and Internet marketing? Probably not, but it is the best I can give you, based on my experience as a marketer, entrepreneur, and writer since 1979. You can read my bio at the back of the book, along with testimonials from my e-newsletter subscribers, to determine whether I am worth listening to.</p>
</a><p class="indent"><a id="page_xvii"></a><a id="page_xviii">I continue to write and distribute the essays online, so if you have a question, e-mail it to me and I may, if I feel qualified and able, answer it in a future issue: <span class="underline"></span></a><a href="mailto:rwbly@bly.com">rwbly@bly.com</a></p>
<p class="indent">In addition, you can get all my future e-mail essays free by signing up for my e-newsletter here: <span class="underline"><a href="http://www.bly.com/reports" target="_blank">www.bly.com/reports</a></span>. When you sign up, you also get 4 free bonus reports totaling 200 pages with a retail value of over $100. Details are on the sign-up page.</p>
<p class="indent">It’s my hope that by reading this book, you will in plain and easy-to-read language get advice and ideas that can help you:</p>
<p class="bullt">•  Get better ROI from your marketing campaigns.</p>
<p class="bull">•  Generate more clicks, leads, and sales on the web.</p>
<p class="bull">•  Start and run a successful Internet marketing business.</p>
<p class="bull">•  Start and manage a successful career as a self-employed professional.</p>
<p class="bull">•  Write more clearly, engagingly, and persuasively.</p>
<p class="bull">•  Manage your time better and improve your personal productivity.</p>
<p class="bullb">•  Achieve a more harmonious work/life balance.</p>
<p class="indent">I sincerely believe that even if you only get one good idea for improving just one of the areas named above, it will pay back the modest cost of this book tenfold or more — not a bad return on your reading investment.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_intro.vue?21593240